<h2 mat-dialog-title>{{jsonOrYaml}} - {{data.name}}</h2>
<mat-dialog-content class="mat-typography">
  <div class="form-container">
    <mat-form-field class="text-monospace">
      <textarea matInput readonly [value]="jsonData" [placeholder]="jsonOrYaml" rows="10" #jsonElem></textarea>
      <button mat-button matSuffix mat-icon-button aria-label="Copy" (click)="copy(jsonElem)"
              matTooltip="Copy to clipboard">
        <mat-icon>file_copy</mat-icon>
      </button>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Done</button>
</mat-dialog-actions>
